export const getKeyForItem = (item: any, index: number): string => {
  const parts = [
    'offer',
    item._id,
    item.id,
    item.alias,
    item.name,
    // ориентируемся на индекс, тк могут быть одинаковые предложения, но разные условия и запихивать все возможные параметры в ключ - невозможно
    index,
  ];

  return parts.filter(Boolean).join('-');
};
